import { useFormApi } from '@data-driven-forms/react-form-renderer';

import { TITLE_ICON_TYPE } from '../QuestionBox/constants';
import ExtractionDataIcon from '../QuestionExtraction/components/ExtractionDataIcon';

function checkIfDirty(initial, value) {
  const pristine = `${initial}` === `${value}`;
  return !pristine;
}

type ExtractionStatusIconProps = {
  defaultStatus?: 'Extraction' | 'User' | 'ExtractionFailed';
  fieldName: string;
  sx?: any;
};

export default function ExtractionStatusIcon({
  defaultStatus,
  fieldName,
  sx,
  ...rest
}: Readonly<ExtractionStatusIconProps>) {
  const { getFieldState } = useFormApi();

  const fieldState = getFieldState(fieldName);

  const dirty = checkIfDirty(fieldState?.initial, fieldState?.value);

  const iconType =
    defaultStatus == 'Extraction'
      ? (dirty && 'User') || 'Extraction'
      : defaultStatus;

  if (!iconType || iconType === 'ExtractionFailed') {
    return null;
  }

  return (
    <ExtractionDataIcon
      iconType={
        iconType === 'Extraction' ? TITLE_ICON_TYPE.BOLT : TITLE_ICON_TYPE.USER
      }
      sx={sx}
      {...rest}
    />
  );
}
